import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css';
import App from './App.vue';
import axios from "axios";
import store from './store/store';
import router from '~/router/router';

import {formatLanguage, initializeLanguage} from '~/utils/utils';

import errorMsg from '~/components/errorMsg/errorMsg.vue'
import areaSelectFooter from '~/components/areaSelectFooter/areaSelectFooter.vue'
import copyright from '~/components/copyright/copyright.vue'
import pageChangeResult from '~/components/pageChangeResult/pageChangeResult.vue'
import goBackButton from '~/components/goBackButton/goBackButton.vue'
import {i18n} from './i18n/index' //国际化
import VueWechatTitle from 'vue-wechat-title'
import {IsInSlicer} from '@/utils/studioWXMessage.js'
import "@/assets/scss/theme.scss";

Vue.component('errorMsg',errorMsg) // 在全局用Vue.component()方法全局注册
Vue.component('areaSelectFooter',areaSelectFooter)
Vue.component('copyright',copyright)
Vue.component('pageChangeResult',pageChangeResult)
Vue.component('goBackButton',goBackButton)
Vue.use(ElementUI)

Vue.use(VueWechatTitle)

store.commit('setIsinSlicer', IsInSlicer());
console.warn(IsInSlicer())

// 初始化语言设置
const initialLanguage = initializeLanguage();
store.commit('setLanguage', initialLanguage); // 设置 Vuex 中的语言
localStorage.setItem('locale', initialLanguage); // 设置 localStorage 中的语言
/**
 * 路由前置守卫
 */
router.beforeEach((to, from, next) => {

  if (to.path != from.path && to.path=="/area/area"){
    store.state.routerUrl=from.path
    console.warn(to.path,from.path)
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.isAuth) {
    //判断 如果school本地存储是qinghuadaxue的时候，可以进去
    if (localStorage.getItem('token')) {
      next()  //放行
    } else {
      // //this.$notify.warning({
      //     title:this.$t('h.common.tip'),
      //     message:this.$t('h.common.tipNeedLogin'),
      // })
      // next({path:'/pageChangeResult',query: { iconTpye:'waring',title:'h.common.refuse',subTitle:'h.common.tipNeedLogin',redirect: '/account/login' }})
      next('/account/login')
    }
  } else {
    // 否则，放行
    next()
  }


  // 读取路由参数
  let l = to.query.l;
  let lang = to.query.lang;
  const subject = to.query.subject;
  const token = to.query.token;
  const qidit = to.query.qidit;
  if (lang) {
    lang = formatLanguage(lang) //特殊处理语言 比如说 zh-tw 这种转为zh,默认语言为英语
    localStorage.setItem('locale', lang); //设置 localStorage 中的语言,默认语言的初始化处理已经在main.js中了
    store.commit('setLanguage', lang); // 设置 Vuex 中的语言
    i18n.locale = localStorage.getItem('locale');
    console.warn("切换语言成功",store.state.language)
  }

  // if (lang !== localStorage.getItem('locale')){
  //   // 克隆当前路由的查询参数对象
  //   var newQuery = Object.assign({}, router.query);
  //   // 添加新的查询参数 l: lang
  //   newQuery.lang = localStorage.getItem('locale');
  //   // 进行路由导航
  //   router.replace({query: newQuery});
  // }

  if (subject) {
    localStorage.setItem('subject', subject); // 设置 localStorage 中的subject
    store.commit('setSubject', subject); // 设置 Vuex 中的主题
  }
  if (token) {
    //如果有正确的token传入 设置覆盖本地token 前往是否继续登录老账号的页面
    localStorage.setItem('token', token);
    store.commit('deleteUserVuex')//清空老账号vuex toekn和用户信息
    store.commit('saveUserToken', token); //设置新账号的token
    router.push('/account/userCenter');
    // window.location.reload();
  } else if (qidit) {
    //如果有正确的token传入 设置覆盖本地token 前往是否继续登录老账号的页面
    localStorage.setItem('token', qidit);
    store.commit('deleteUserVuex')//清空老账号vuex toekn和用户信息
    store.commit('saveUserToken', qidit); //设置新账号的token
    router.push('/account/userCenter');
    // window.location.reload();
  }
  // 打印路由参数
  console.log(`读取得到的参数 Language: ${lang}, Subject: ${subject}, token: ${token}, qidit: ${qidit}`);
})


//后置路由守卫————初始化的时候被调用、每次路由切换之后被调用
router.afterEach((to, from) => {

  // if(to.path=="/area/area" && from.path !=to.path){
  // console.warn(to.path,from.path)
  // store.commit('setrouterUrl', from.path)
  // console.warn('记录的路径~',store.state.routerUrl)
  // }

  // if (to.path=="/account/register"){
  //   store.commit('setrouterUrl', "/account/login")
  // }else if(to.path=="/account/forgotPassword"){
  //   store.commit('setrouterUrl', "/account/login")
  // }else if(to.path=="/account/changePassword"){
  //   store.commit('setrouterUrl', "/account/userCenter")
  // }else if(to.path=="/account/deleteUser"){
  //   store.commit('setrouterUrl', "/account/deleteUser")
  // }

})

new Vue({
  el: '#app',
  render: h => h(App),
  //引入导出的router
  router,
  store,
  axios,
  i18n,
})



// WEBPACK FOOTER //
// ./src/main.js